module.exports = __webpack_public_path__ + "img/icon-speed-2.7ab5bcec.svg";